<template>
  <v-col>
    <v-row class="mb-8">
      <v-btn
        color="primary"
        @click="CHANGE_FORMAZIONE_COMPONENT('Index')"
      >Indietro</v-btn>
    </v-row>
    <v-row
      align="center"
      justify="center"
    >
      <v-card min-width="100%">
        <v-form
          ref="form"
          v-model="valid"
          :lazy-validation="true"
          autocomplete="off"
        >
          <v-card-text>
            <v-col>
              <v-row>
                <v-col>
                  <v-text-field
                    label="Nome"
                    v-model="newLesson.name"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    label="Prezzo"
                    type="number"
                    v-model="newLesson.price"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-card-text>
          <v-card-actions>
            <v-col>
              <v-row>
                <v-col>
                  <v-btn
                    :disabled="!valid"
                    color="success"
                    class="mr-4"
                    @click="submit"
                  >
                    Inserici Lezione
                  </v-btn>

                  <v-btn
                    color="error"
                    class="mr-4"
                    @click="reset"
                  >
                    Reset Modulo
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-row>
    <snack-notification :snack="snack" />
  </v-col>
</template>

<script>
  import axios from 'axios'
  import { mapMutations } from 'vuex'

  import SnackNotification from './../../SnackNotification'

  export default {
    name: 'Insert',
    components: {
      SnackNotification
    },
    data() {
      return {
        newLesson: {
          name: null,
          price: null,
        },
        valid: false,
        snack: {
          error: null,
          visible: null,
          message: null
        },
        rules: {
          required: value => !!value || 'Campo obbligatorio.',
        },
        config: {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
          }
        },
      }
    },
    methods: {
      ...mapMutations([
        'CHANGE_FORMAZIONE_COMPONENT'
      ]),
      async submit() {
        if (this.$refs.form.validate()) {

          this.snack = Object.assign({}, {
            error: null,
            visible: null,
            message: null
          })

          const { data } = await axios.post(`${process.env.VUE_APP_API}/lessons/create`, this.newLesson, this.config)

          if (data.status) {

            this.snack = Object.assign({}, {
              visible: true,
              error: false,
              message: 'Articolo salvato correttamente!'
            })
          } else {

            this.snack = Object.assign({}, {
              visible: true,
              error: true,
              message: 'Errore nel salvataggio.'
            })
          }

        }
      },
      reset() {
        this.$refs.form.reset()
      },
    },
    computed: {
      //
    },
    watch: {
      //
    }
  }
</script>

<style>
</style>